import React, { useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridSortModel,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import "./styles.scss";
import "./styles.scss";
import dayjs from "dayjs";
import { EmailLogType } from "../../types/genericType";
import SearchField from "../common/Search/SearchField";
import "./styles.scss";
import { Box } from "@mui/material";

type EmailLogTableProps = {
  data: Array<EmailLogType>;
  search: string;
  clearSearch: Function;
  // eslint-disable-next-line no-unused-vars
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const EmailLogTable = (props: EmailLogTableProps) => {
  const { data, search, onSearchChange, clearSearch } = props;

  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "date", sort: "desc" },
  ]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setSortModel(newSortModel);
  };

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "date",
        headerName: "Date",
        minWidth: 150,
        sortable: true,
        valueFormatter: (params: GridValueFormatterParams) =>
          dayjs(params.value).format("MM/DD/YYYY"),
        headerClassName: "header-datagrid",
      },
      {
        field: "email",
        headerName: "Recipient",
        minWidth: 300,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "subject",
        headerName: "Subject",
        minWidth: 700,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "status",
        headerName: "Status",
        minWidth: 150,
        sortable: false,
        headerClassName: "header-datagrid",
      },
    ],
    []
  );

  return (
    <div className="data-table">
      <Box className="heading-row">
        <SearchField
          onSearchChange={onSearchChange}
          search={search}
          clearSearch={clearSearch}
        />
      </Box>
      <DataGrid
        rows={data}
        getRowId={(row) => row.id}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        pageSizeOptions={[10, 20, 30, 40, 50]}
        className="datagrid"
      />
    </div>
  );
};

export default EmailLogTable;
